<div id="tabs-component" [ngClass]="componentClassname">
    <app-overflow-container 
        class="_w-full"
        [indentArrows]="false">
        <div 
            class="tab-buttons" 
            [ngClass]="!!tabsClassname ? tabsClassname  : ''"
            #tabButtons>
            
            <ng-container *ngFor="let button of buttonsData; index as i">
                <button
                    #tabButton
                    class="_button-reset"
                    [disabled]="button.disabled"
                    [ngClass]="[
                        button.hidden ? '_hidden' : '',
                        button.disabled ? '_pointer-events-none' : '',
                        activeTabIndex == i + 1 ? 'active-tab': '', 
                        activeTabIndex == i + 1 && !!buttonActiveClassname ? buttonActiveClassname : '',
                        !!buttonClassname ? buttonClassname  : ''
                    ]"
                    [attr.data-tab-button-index]="i + 1"
                    [attr.data-tab-button-id]="button.tabId || 'id_' + i"
                    (click)="switchActiveTab(i + 1, button.tabContentIndex)">
                    <span *ngIf="button.html" [innerHtml]="button.html"></span>
                    <span *ngIf="!button.html">{{button.label}}</span>
                </button>
            </ng-container>
        
            <ng-content select="[slot=tab-buttons]"></ng-content>
        </div>
    </app-overflow-container>
    <div 
        class="tab-content" 
        [ngClass]="[
            activeTabContentClassname,
            tabContentContainerClassname ? tabContentContainerClassname : '']"
        #tabContent>
        <ng-content select="[slot=tab-content]"></ng-content>
    </div>
</div>
